module.exports = "<li class=\"c-nav__list-item\" ng-if=\"$ctrl.isLoginAllowed() && !$ctrl.isLoggedIn()\">\n    <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=\"$ctrl.login()\">Log in</a>\n</li>\n\n<li ng-if=\"$ctrl.isLoggedIn()\">\n    <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=\"$ctrl.logout()\">Log out</a>\n    <span class=\"c-nav__list-item__description\">Logged in as: {{ $ctrl.storeService.get('client_name') }}</span>\n</li>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/logInOut.menu.html
// module id = 793
// module chunks = 0